module.exports = __webpack_public_path__ + "assets/add.fb4d1af2.svg";